const getFSKColors = theme => () => {
    if('Dark' === theme) {
        return {
            "fsk-unknown": "#FFFFFF",
            "fsk-0": "#FFFFFF",
            "fsk-6": "#F0EC10",
            "fsk-12": "#31AE3F",
            "fsk-15": "#f39200",
            "fsk-16": "#36A2DC",
            "fsk-18": "#E51A23"
        }
    } else if('Light' === theme) {
        return {
            "fsk-unknown": "#000000",
            "fsk-0": "#000000",
            "fsk-6": "#ddad10",
            "fsk-12": "#31AE3F",
            "fsk-15": "#f39200",
            "fsk-16": "#36A2DC",
            "fsk-18": "#E51A23"
        }
    } else if('Kmotion' === theme) {
        return {
            "fsk-unknown": "#FFFFFF",
            "fsk-0": "#FFFFFF",
            "fsk-6": "#F0EC10",
            "fsk-12": "#31AE3F",
            "fsk-15": "#f39200",
            "fsk-16": "#36A2DC",
            "fsk-18": "#E51A23"
        }
    }  else if('Arthouse' === theme) {
        return {
            "fsk-unknown": "#000000",
            "fsk-0": "#000000",
            "fsk-6": "#ddad10",
            "fsk-12": "#31AE3F",
            "fsk-15": "#f39200",
            "fsk-16": "#36A2DC",
            "fsk-18": "#E51A23"
        }
    }
}

export default getFSKColors